import React, { useEffect, useContext, useState } from 'react';
import { AppContext } from '../util/AppContext';
import { getConfigValue } from '../util/getConfigValue';

import AnouncementsCard from '../components/leaderboard/AnnouncementsCard';
import LeaderTableCard from '../components/leaderboard/LeaderTableCard';
import SignedInUsers from '../components/leaderboard/SignedInUsersCard';
import UserLeaderboardReportingFilters from '../components/reportFilter/UserLeaderboardReportingFilters';
import { getUserLeaderboardStatsData } from '../API/UtilizationReportingDashboard';
import { useErrorBoundary } from "react-error-boundary";
import { useBreadcrumbs } from '../util/BreadcrumbContext';
import PageTitle from '../components/PageTitle';
import PageContextMenu from '../components/PageContextMenu';

function LeaderboardPage() {
    const [appState] = useContext(AppContext);
    const leaderboardEnabled = getConfigValue(appState?.config?.Leaderboard?.Enabled, appState)?.Value === 'true' || false;
    const [filterState, setFilterState] = useState({ timePeriodId: null });
    const [isLoading, setIsLoading] = useState(true);
    const [userData, setUserData] = useState({});
    const [allUserData, setAllUserData] = useState([]);
    const { showBoundary } = useErrorBoundary();
    const {setBreadcrumbs } = useBreadcrumbs();

    useEffect(() => {
        setBreadcrumbs([
            { label: getConfigValue(appState?.config?.Leaderboard?.Label, appState)?.Value, path: "/Leaderboard"}
        ]);
    }, [setBreadcrumbs]);

    useEffect(() => {
        if (leaderboardEnabled && appState?.config && filterState.timePeriodId !== null) {
            setIsLoading(true);
            getData();
        }
    }, [filterState.timePeriodId, filterState.selectedProductIds]);

    const getData = async () => {
        await getUserLeaderboardStatsData({
            "timeFilter": filterState.timePeriodId,
            "includePriorPeriod": filterState.includePriorPeriod,
            "maxUsers": getConfigValue(appState?.config?.Leaderboard?.Charts?.LeaderTable?.MaxRecords, appState)?.Value || 25,
            "productIds": filterState.selectedProductIds
        })
            .then((responseJson) => {
                if (responseJson !== undefined) {
                    setUserData(responseJson?.currentPeriod?.userStats)
                    setAllUserData(responseJson?.currentPeriod?.allUserStats)
                    setIsLoading(false);
                }
            })
            .catch((err) => {
                showBoundary(err);
            });
    }

    return leaderboardEnabled && (
        <div>
            <div className='container-xl'>
                <div className='row'>
                    <div className='d-flex justify-content-between align-items-center mb-3 mt-3 mt-4'>
                        <PageTitle title={getConfigValue(appState?.config?.Leaderboard?.Label, appState)?.Value || null} />
                        <PageContextMenu includeExportOption={false} />
                    </div>                             
                </div>
                <div className='row'>

                    <div className="d-flex justify-content-between align-items-center responsive-header-bar">
                        <UserLeaderboardReportingFilters
                            filterState={filterState}
                            setFilterState={setFilterState}
                        ></UserLeaderboardReportingFilters>

                    </div>

                    <div className='tab-content pt-5 mt-4'>
                        <SignedInUsers userStats={userData} isLoading={isLoading} filterState={filterState}></SignedInUsers>
                        <LeaderTableCard userReportData={allUserData} isLoading={isLoading} filterState={filterState}></LeaderTableCard>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default LeaderboardPage;
